module.exports = __webpack_public_path__ + "static/media/Instagram01.41266941.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Instagram01.svg
// module id = 330
// module chunks = 0